import {
  Component,
  Inject,
  OnInit,
  ChangeDetectionStrategy
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'aid-confirm-dialog',
  template: `
    <aid-dialog
      class="confirm-dialog"
      [title]="data.title"
      [closeButton]="false"
    >
      <div
        class="confirm-dialog__container aid-layout-column aid-layout-gap-20"
      >
        <div class="mat-subtitle-2 confirm-dialog__subtitle">
          {{ data.message | translate }}
        </div>
        <aid-form-actions
          [buttonLeft]="'cancel'"
          [buttonRight]="'confirm'"
          (clickLeft)="onCancel()"
          (clickRight)="onConfirm()"
          data-cy="aid-confirm-dialog"
        ></aid-form-actions>
      </div>
    </aid-dialog>
  `,
  styleUrls: ['./confirm-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ConfirmDialogComponent implements OnInit {
  constructor(
    private dialogRef: MatDialogRef<ConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      title: string;
      message: string;
    }
  ) {}

  ngOnInit() {}

  onCancel() {
    this.dialogRef.close(false);
  }

  onConfirm() {
    this.dialogRef.close(true);
  }
}
